import React from "react";
import { CheckIcon } from "@heroicons/react/24/outline";

const CustomCheckBox = ({ title, isChecked, onChange }) => {
  return (
    <div className="m-[0.125rem] mt-4 block min-h-[1.5rem]" dir="">
      {/* Custom Checkbox */}
      <div
        className="flex items-center gap-2 cursor-pointer"
        onClick={onChange}
      >
        <div
          className={`relative w-4 h-4 lg:w-5 lg:h-5 rounded flex items-center justify-center border-2 ${
            isChecked
              ? "bg-custom-yellow border-custom-yellow"
              : "bg-white border-gray-300"
          }`}
        >
          {isChecked && <CheckIcon className="w-4 h-4 text-black" />}
          <input
            type="checkbox"
            className="absolute inset-0 opacity-0 cursor-pointer"
            checked={isChecked}
          />
        </div>
        <span className="text-gray-700 ">{title}</span>
      </div>
    </div>
  );
};

export default CustomCheckBox;
